import React,{Component} from 'react';
import '../right-selectors.scss';

export default class SelectorTitle extends Component{
  constructor(props) {
    super(props);
  }

  render() {
    return(
      <p className="title-name">{this.props.title}</p>
    );
  }
}
